import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { ThumbsUp, ThumbsDown, Send } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const FeedbackWidget = ({ context = 'story_saved' }) => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const [status, setStatus] = useState('idle');

  const submit = async (chosenRating, withComment) => {
    setStatus('sending');
    try {
      await axios.post(
        `${API}/feedback`,
        { rating: chosenRating, comment: withComment ? comment.trim() : '', context },
        { withCredentials: true }
      );
      setStatus('done');
    } catch {
      setStatus('done');
    }
  };

  const pick = (r) => {
    setRating(r);
    if (r === 'up') submit(r, false);
  };

  if (status === 'done') {
    return (
      <div className="bg-emerald-50 border border-emerald-200 text-emerald-700 px-4 py-3 rounded-lg text-sm" data-testid="feedback-thanks">
        Thanks — your feedback helps shape Flash Fiction!
      </div>
    );
  }

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3" data-testid="feedback-widget">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="text-sm font-medium text-amber-900">Was this writing session useful?</p>
        <div className="flex items-center space-x-2">
          <button
            type="button"
            onClick={() => pick('up')}
            disabled={status === 'sending'}
            className="p-2 rounded-full bg-white border border-amber-200 hover:bg-emerald-50 hover:border-emerald-300 transition-colors"
            data-testid="feedback-thumbs-up"
          >
            <ThumbsUp className="h-4 w-4 text-emerald-600" />
          </button>
          <button
            type="button"
            onClick={() => pick('down')}
            disabled={status === 'sending'}
            className={`p-2 rounded-full border transition-colors ${
              rating === 'down' ? 'bg-rose-50 border-rose-300' : 'bg-white border-amber-200 hover:bg-rose-50 hover:border-rose-300'
            }`}
            data-testid="feedback-thumbs-down"
          >
            <ThumbsDown className="h-4 w-4 text-rose-600" />
          </button>
        </div>
      </div>
      {rating === 'down' && (
        <div className="mt-3 flex gap-2">
          <input
            type="text"
            maxLength={300}
            placeholder="What could be better? (optional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            className="flex-1 px-3 py-2 text-sm rounded-lg border border-amber-200 bg-white text-amber-950 placeholder:text-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-500"
            data-testid="feedback-comment-input"
          />
          <Button
            size="sm"
            onClick={() => submit('down', true)}
            disabled={status === 'sending'}
            className="bg-amber-900 hover:bg-amber-800 text-amber-50"
            data-testid="feedback-submit-button"
          >
            <Send className="h-3.5 w-3.5" />
          </Button>
        </div>
      )}
    </div>
  );
};
